module.exports = "App.Collections.ContactEmails = Backbone.Collection.extend({\n\n  model: App.Models.ContactEmail\n  \n});\n"